import { reportError, reportWarning } from './reporter';
import { DEFAULT_FLOW_ID } from 'src/dataLayer/env';
import { ReportError } from './types';


export const reportUncaughtException = (error: ErrorEvent): ReportError =>
  reportError('uncaught:exception', error);

export const reportUIError = (component: string, description: string, error: Error): ReportError =>
  reportWarning(`Error in component: ${component}`, {
    error,
    description
  });

export const reportFlowLoadingError = (flowId: string, error: Error): ReportError => {
  if (flowId === DEFAULT_FLOW_ID) {
    void reportError(`loading:${DEFAULT_FLOW_ID}:flow`, {
      flowId,
      error
    });
    return;
  }

  void reportWarning('loading:custom:flow', {
    flowId,
    error
  });
};

/**
 * Reports missing cookie(s)
 * e.g. we should not invoke ab-tester unless we have a tracking uuid
 */
export const reportCookieFailure = (cookieName: string): ReportError =>
  reportWarning(`cookies:${cookieName}:failed`, {});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const reportEmptyUserRegistrationAttempt = (user: any): ReportError =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  reportError('user:registration:failure:usertype', { user });
